import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-sm text-(--colors-text-body-subtle)",
    "data-testid": "donation-settings-email-templates-catalogue-error"
};
const _hoisted_2 = {
    class: "text-sm text-(--colors-text-body-subtle)",
    "data-testid": "donation-settings-email-templates-required-hint"
};
const _hoisted_3 = { class: "flex flex-col gap-4" };
import { Alert } from "@eudonet/opal";
import { TAX_RECEIPT_EMAIL_CONTEXTS, } from "../../../domain/entities/taxReceiptEmailContexts";
import DonationSettingsEmailContextCard from "./DonationSettingsEmailContextCard.vue";
import DonationSettingsBlockState from "./DonationSettingsBlockState.vue";
import DonationSettingsSection from "./DonationSettingsSection.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsEmailTemplatesTab',
    props: {
        contexts: {},
        templateOptions: {},
        isLoading: { type: Boolean },
        loadError: { type: Boolean },
        templatesLoadError: { type: Boolean },
        invalidContexts: {}
    },
    emits: ["retry", "update:defaultTemplate", "update:subject"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DonationSettingsSection, {
                title: _ctx.$t('finance.taxReceipts.settings.emailTemplates.title'),
                subtitle: _ctx.$t('finance.taxReceipts.settings.emailTemplates.subtitle'),
                "test-id": "donation-settings-email-templates"
            }, {
                default: _withCtx(() => [
                    _createVNode(DonationSettingsBlockState, {
                        "is-loading": __props.isLoading,
                        "load-error": __props.loadError,
                        "error-key": "finance.taxReceipts.settings.emailTemplates.loadError",
                        "test-id": "donation-settings-email-templates",
                        onRetry: _cache[0] || (_cache[0] = ($event) => (emit('retry')))
                    }, {
                        default: _withCtx(() => [
                            (__props.templatesLoadError)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t("finance.taxReceipts.settings.emailTemplates.templatesLoadError")), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("finance.taxReceipts.settings.requiredFieldsHint")), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TAX_RECEIPT_EMAIL_CONTEXTS), (context) => {
                                    return (_openBlock(), _createBlock(DonationSettingsEmailContextCard, {
                                        key: context,
                                        context: context,
                                        value: __props.contexts[context],
                                        "template-options": __props.templateOptions,
                                        "default-template-missing": __props.contexts[context].defaultTemplateId === null,
                                        "show-required-error": __props.invalidContexts.includes(context),
                                        "test-id": `donation-settings-email-${context}`,
                                        "onUpdate:defaultTemplate": ($event) => (emit('update:defaultTemplate', context, $event)),
                                        "onUpdate:subject": ($event) => (emit('update:subject', context, $event))
                                    }, null, 8 /* PROPS */, ["context", "value", "template-options", "default-template-missing", "show-required-error", "test-id", "onUpdate:defaultTemplate", "onUpdate:subject"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["is-loading", "load-error"]),
                    _createVNode(_unref(Alert), {
                        color: "warning",
                        message: _ctx.$t('finance.taxReceipts.settings.emailTemplates.missingInformation'),
                        "data-testid": "donation-settings-email-templates-missing-information"
                    }, null, 8 /* PROPS */, ["message"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle"]));
        };
    }
});
